import StarBorderIcon from '@mui/icons-material/StarBorder';
import StarIcon from '@mui/icons-material/Star';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import { useState} from "react";
import { useAuth } from "./Auth/AuthPage.jsx";
import {ButtonGroup, Link, Snackbar, Typography} from "@mui/material";
import {LeadFollowNoneIndicator} from "./LeadFollowNoneIndicator.jsx";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import { useRSVP } from './RSVPContext.jsx';

const Container = (props) => {
    const style = {
        borderRadius: "6px",
        display: "flex",
        flexDirection: "row",
        padding: "5px 0px 0px 0px",
        margin: "0px 0px 0px 0px"
    }

    return <div style={{height: "100%", verticalAlign: "middle"}}>
        <div style={style}>
            {props.children}
        </div>
    </div>
}

const RSVPButton = (props) => {
    const {isRSVP, counts, toggle, setSnackBarMessage, setSnackBarOpen} = useRSVP()

    const [loading, setLoading] = useState(false);
    const [showLFCounts, setShowLFCounts] = useState(false)
    const { loggedIn } = useAuth();
    const {date, venueKey} = props;
    const rsvpKey = date + "-" + venueKey
    const selected = isRSVP(rsvpKey)
    const { leads, follows, other, total } = counts(rsvpKey);

    const requireLogin = () => {
        setSnackBarOpen(true);
        setSnackBarMessage("You must log in to star events");
    }

    let starIcon, starHandler
    let lfHandler = () => setShowLFCounts(!showLFCounts)
    if (!loggedIn) {
        starIcon = <StarBorderIcon  style={{color: "#ffffff"}}/>
        starHandler = requireLogin
        lfHandler = requireLogin

    } else if (loading) {
       starIcon = <AutorenewIcon  sx={{
           animation: "spin 2s linear infinite",
           "@keyframes spin": {
               "0%": {
                   transform: "rotate(0deg)",
               },
               "100%": {
                   transform: "rotate(360deg)",
               },
           },
       }} />
       starHandler = () => {}
   } else if (selected) {
        starIcon = <StarIcon style={{color: "yellow"}} size={"small"}/>
        starHandler = () => toggle(rsvpKey, setLoading)
    } else {
        starIcon = <StarBorderIcon style={{color: "white"}}/>
        starHandler = () => toggle(rsvpKey, setLoading)
    }

    const content = loggedIn ?
     <div style={{margin: "20px"}}>
        <p>{leads} Leads</p>
        <p>{follows} Follows</p>
        <p>{other} Other</p>
    </div> :
        <div>
            <Link>Login</Link> to enable:
            <ul>
                <li>RSVP</li>
                <li>lead / follow counts</li>
                <li>calendar integration</li>
            </ul>
        </div>


    return <Container>
        <ButtonGroup variant={"contained"} sx={{background: "#cc66cc"}} >
            <Button sx={{width: "10px", height: "22px", background: "#393536", borderRight: "1px solid #333333"}} onClick={starHandler}>
                {starIcon}
            </Button>
            {loggedIn && <Button sx={{width: "50px", height: "22px", background: "#393536"}} onClick={lfHandler}>
                <div style={{display: "flex", flexDirection: "row", justifyContent:"space-evenly"}}>
                    {loggedIn && <div style={{margin: "0px 8px 0px 8px"}}>
                        <Typography variant={"body2"} sx={{color: "#FFFFFF"}}>{total}</Typography>
                    </div>}
                    {loggedIn && <LeadFollowNoneIndicator leads={leads} follows={follows} other={other} />}
                </div>
            </Button>}
        </ButtonGroup>
        <Dialog open={showLFCounts} onClose={lfHandler}>{content}</Dialog>
    </Container>


}

const RSVPButtonLight = (props) => {
    const {isRSVP, toggle} = useRSVP()
    const [loading, setLoading] = useState(false);
    const {loggedIn } = useAuth();
    const {date, venueKey} = props;
    const rsvpKey = date + "-" + venueKey
    const selected = isRSVP(rsvpKey)
    const [snackBarOpen, setSnackBarOpen] = useState(false);
    const [snackBarMessage, setSnackBarMessage] = useState("");

    const requireLogin = () => {setSnackBarOpen(true); setSnackBarMessage("You must log in to star events")}

    let starIcon, starHandler
    // let lfHandler = () => setShowLFCounts(!showLFCounts)
    if (!loggedIn) {
        starIcon = <StarBorderIcon  style={{color: "#ffffff"}}/>
        starHandler = requireLogin
        // lfHandler = requireLogin

    } else if (loading) {
        starIcon = <AutorenewIcon  sx={{
            animation: "spin 2s linear infinite",
            "@keyframes spin": {
                "0%": {
                    transform: "rotate(0deg)",
                },
                "100%": {
                    transform: "rotate(360deg)",
                },
            },
        }} />
        starHandler = () => {}
    } else if (selected) {
        starIcon = <StarIcon style={{color: "yellow"}} size={"small"}/>
        starHandler = () => toggle(rsvpKey, setLoading)
    } else {
        starIcon = <StarBorderIcon style={{color: "white"}}/>
        starHandler = () => toggle(rsvpKey, setLoading)
    }

    return <Container>
        <Snackbar
            open={snackBarOpen}
            message={snackBarMessage}
            autoHideDuration={2500}
            onClose={() => setSnackBarOpen(false)}
        />
        <ButtonGroup variant={"contained"} sx={{background: "#cc66cc"}} >
            <Button sx={{width: "10px", height: "22px", background: "#393536", borderRight: "1px solid #333333"}} onClick={starHandler}>
                {starIcon}
            </Button>
        </ButtonGroup>
    </Container>


}


export { RSVPButton, RSVPButtonLight };